<template>
  <v-breadcrumbs class="pa-0" :items="breadcrumbs">
    <template v-slot:divider>
      <v-icon>fas fa-chevron-right</v-icon>
    </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item :disabled="item.disabled">
        <strong v-if="item.disabled">{{ item.text }}</strong>
        <router-link
          class="none-text-decoration font-weight-bold"
          v-else-if="item.name !== $route.name && !item.disabled"
          :to="{ path: item.to, query: item.query }"
          >{{ item.text }}</router-link
        >
        <strong v-else>{{ item.text }}</strong>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>
<script>
export default {
  store: ["breadcrumbs"],
  name: "Breadcrumbs",

  created() {
    this.setBreadcrumbs();
  },
  watch: {
    $route: function () {
      this.setBreadcrumbs();
    },
    "$route.meta.title": function () {
      this.setBreadcrumbs();
    },
  },
  methods: {
    setBreadcrumbs() {
      var breadcrumb = this.$ls.get("Breadcrumbs") || [...this.breadcrumbs];
      // let menuList = this.$ls.get("Menu_List")
      console.log(this.$route);
      switch (this.$route.name) {
        case "List General OF Season":
          this.breadcrumbs = [
            {
              text: this.$route.query.season,
              to: this.$route.path,
              name: this.$route.name,
              query: this.$route.query,
              disabled: true,
            },
          ];
          this.breadcrumbs.push({
            text: this.$route.query.questionNo,
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Create General OF Season":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "List General OF Season"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Sort List General OF Season":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "List General OF Season"
          );
          this.breadcrumbs.push({
            text: this.$route.query.questionNo,
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Select Create General OF Season":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "List General OF Season"
          );
          this.breadcrumbs.push({
            text: this.$route.query.questionNo,
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Update General OF Season":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "List General OF Season"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Detail General OF Season":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "List General OF Season"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "List General OF Chapter":
          this.breadcrumbs = [
            {
              text: this.$route.query.season,
              to: this.$route.path,
              name: this.$route.name,
              query: this.$route.query,
              disabled: true,
            },
            {
              text: this.$route.query.chapter,
              to: this.$route.path,
              name: this.$route.name,
              query: this.$route.query,
              disabled: true,
            },
          ];
          this.breadcrumbs.push({
            text: this.$route.query.questionNo,
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Sort List General OF Chapter":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "List General OF Chapter"
          );
          this.breadcrumbs.push({
            text: this.$route.query.questionNo,
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Select Create General OF Chapter":
          console.log("Select Create General OF Chapter");
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "List General OF Chapter"
          );
          this.breadcrumbs.push({
            text: this.$route.query.questionNo,
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Create General OF Chapter":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "List General OF Chapter"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Update General OF Chapter":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "List General OF Chapter"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Detail General OF Chapter":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "List General OF Chapter"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "List General OF Section":
          this.breadcrumbs = breadcrumb.filter(
            (e) =>
              e.text == this.$route.query.season ||
              e.text == this.$route.query.chapter ||
              e.text == this.$route.query.section
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Sort List General OF Section":
          this.breadcrumbs = breadcrumb.filter(
            (e) =>
              e.text == this.$route.query.season ||
              e.text == this.$route.query.chapter ||
              e.text == this.$route.query.section ||
              e.name == "List General OF Section"
          );
          this.breadcrumbs.push({
            text: this.$route.query.questionNo,
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Create General OF Section":
          this.breadcrumbs = breadcrumb.filter(
            (e) =>
              e.name == "Detail Section" || e.name == "List General OF Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Update General OF Section":
          this.breadcrumbs = breadcrumb.filter(
            (e) =>
              e.name == "Detail Section" || e.name == "List General OF Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Detail General OF Section":
          this.breadcrumbs = breadcrumb.filter(
            (e) =>
              e.name == "Detail Section" || e.name == "List General OF Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Detail Section":
          this.breadcrumbs = [
            {
              text: this.$route.query.season,
              to: this.$route.path,
              name: this.$route.name,
              query: this.$route.query,
              disabled: true,
            },
            {
              text: this.$route.query.chapter,
              to: this.$route.path,
              name: this.$route.name,
              query: this.$route.query,
              disabled: true,
            },
          ];
          this.breadcrumbs.push({
            text: this.$route.query.section,
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Add Grammar OF Section":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Detail Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Detail Skit":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Detail Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Update Grammar Of Self Study":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Detail Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Detail conversation":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Detail Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Update Grammar OF Section":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Detail Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Detail expression":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Detail Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Detail content":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Detail Section" || e.name == "Detail expression"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Vocabulary Book":
        case "Version":
          this.breadcrumbs = [
            {
              text: this.$t(this.$route.meta.title),
              to: this.$route.fullPath,
              name: this.$route.name,
            },
          ];
          break;
        case "Detail Tab":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Vocabulary Book"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Detail Category":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Vocabulary Book" || e.name == "Detail Tab"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Create Vocabulary In Detail Category":
          this.breadcrumbs = breadcrumb.filter(
            (e) =>
              e.name == "Vocabulary Book" ||
              e.name == "Detail Tab" ||
              e.name == "Detail Category"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Update Vocabulary In Detail Category":
          this.breadcrumbs = breadcrumb.filter(
            (e) =>
              e.name == "Vocabulary Book" ||
              e.name == "Detail Tab" ||
              e.name == "Detail Category"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Add Expression OF Section":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Detail Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Update Expression OF Section":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Detail Section"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.path,
            name: this.$route.name,
            query: this.$route.query,
          });
          break;
        case "Grammar Of Self Study":
          this.breadcrumbs = [
            {
              text: this.$t(this.$route.meta.title),
              to: this.$route.fullPath,
              name: this.$route.name,
            },
          ];
          break;
        case "Grammar Create Of Self Study":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Grammar Of Self Study"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.fullPath,
            name: this.$route.name,
          });
          break;
        case "Grammar Update Of Self Study":
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Grammar Of Self Study"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.fullPath,
            name: this.$route.name,
          });
          break;
        case "Time":
          this.breadcrumbs = [
            {
              text: this.$t(this.$route.meta.title),
              to: this.$route.fullPath,
              name: this.$route.name,
            },
          ];
          break;
        case "Date":
          this.breadcrumbs = [
            {
              text: this.$t(this.$route.meta.title),
              to: this.$route.fullPath,
              name: this.$route.name,
            },
          ];
          break;
        case "Drill":
          this.breadcrumbs = [
            {
              text: this.$t(this.$route.meta.title),
              to: this.$route.fullPath,
              name: this.$route.name,
            },
          ];
          break;
        case "List Exercises Of Drill":
          this.breadcrumbs = [];
          this.breadcrumbs = breadcrumb.filter((e) => e.name == "Drill");
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.fullPath,
            name: this.$route.name,
          });
          break;
        case "Create Exercises Of Drill":
          this.breadcrumbs = [];
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Drill" || e.name == "List Exercises Of Drill"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.fullPath,
            name: this.$route.name,
          });
          break;
        case "Update Exercises Of Drill":
          this.breadcrumbs = [];
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Drill" || e.name == "List Exercises Of Drill"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.fullPath,
            name: this.$route.name,
          });
          break;
        case "Detail Exercises Of Drill":
          this.breadcrumbs = [];
          this.breadcrumbs = breadcrumb.filter(
            (e) => e.name == "Drill" || e.name == "List Exercises Of Drill"
          );
          this.breadcrumbs.push({
            text: this.$t(this.$route.meta.title),
            to: this.$route.fullPath,
            name: this.$route.name,
          });
          break;
      }
      this.$ls.set("Breadcrumbs", this.breadcrumbs);
    },
  },
};
</script>